import { QuestionNode } from './question-node';

/**
 * è¯é¢æä»¶å¤¹
 */
export class QuestionFolder extends QuestionNode {
  /**
   * æä»¶å¤¹åå­
   */
  name: string = undefined;
}
